import { render, staticRenderFns } from "./PTable.vue?vue&type=template&id=76777d2f&scoped=true&"
import script from "./PTable.vue?vue&type=script&lang=js&"
export * from "./PTable.vue?vue&type=script&lang=js&"
import style0 from "./PTable.vue?vue&type=style&index=0&id=76777d2f&prod&lang=scss&scoped=true&"
import style1 from "./PTable.vue?vue&type=style&index=1&id=76777d2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76777d2f",
  null
  
)

export default component.exports